import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
const ConsignmentAssignedVehicleDefinitionList = ({ driver }) => {
    if (driver && driver.id) {
        return (_jsxs("dl", { children: [_jsx("dt", { children: "Name" }), _jsxs("dd", { children: [driver.firstName, " ", driver.lastName] }), _jsx("dt", { children: "Mobile Telephone" }), _jsx("dd", { children: driver.mobileNo }), _jsx("dt", { children: "Email" }), _jsx("dd", { children: ("email" in driver && driver.email)
                        ? _jsx("span", { children: driver.email })
                        : _jsx("span", { children: "\u2014" }) })] }));
    }
    else {
        return _jsx("p", { children: "No driver" });
    }
};
export default ConsignmentAssignedVehicleDefinitionList;
